import { CallbackType, FRWebAuthn, StepType, WebAuthnStepType } from '@forgerock/javascript-sdk';
import { nextStepWithChecks, progressToChannelSelect } from '../commonSteps';
import { getCallbackOfTypeSafely } from '../../../../utils/authTreeUtils';
import AuthTreeError from 'utils/authTree/AuthTreeError';

const OTPChannels = {
  Mobile: 0,
  Email: 1,
  BackupEmail: 2,
  WebAuthN: 3,
};

// This seems to be the closest to identifying User's cancel from WebAuth dialog box
// Chrome/Edge in (all OS) - The operation either timed out or was not allowed
// Chrome (Android) - The request was cancelled
// Safari (macOS, iOS/iPadOS) - The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission
// Firefox (all OS) - 'The operation was aborted' or 'The operation was cancelled'
export const WEBAUTHN_CANCEL_MESSAGES = [
  'The operation either timed out or was not allowed.',
  'The request was cancelled.',
  'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.',
  'The operation was aborted.',
  'The operation was cancelled.',
];

export const REDIRECT_SUCCESS = 'RedirectSuccess';

export default async function chooseChannel(dispatch, step, otpChannel) {
  let currentStep = step;

  const choiceCallback = getCallbackOfTypeSafely(currentStep, CallbackType.ChoiceCallback);
  if (!choiceCallback) {
    return currentStep;
  }

  choiceCallback.setChoiceIndex(otpChannel);
  currentStep = await nextStepWithChecks(dispatch, currentStep);

  const webAuthnStep = otpChannel === OTPChannels.WebAuthN ? FRWebAuthn.getWebAuthnStepType(currentStep) : null;
  if (webAuthnStep === WebAuthnStepType.Authentication) {
    try {
      // Authenticate with a registered device
      currentStep = await FRWebAuthn.authenticate(currentStep);
    } catch (error) {
      if (
        error?.name === 'NotAllowedError' ||
        WEBAUTHN_CANCEL_MESSAGES.some((cancelMsg) => error?.message?.includes(cancelMsg))
      ) {
        // Seems to be the only way to handle User cancelling out of WebAuthn popup
        // The FRWebAuthn.authenticate doesn't seem to pass error.name
        // It has error.message and error.stack but both of them have the same message
        // manage-id has FRWebAuthn.register(), which contains both error.name and error.message
        return null; // Because there's no need for navigation in OnDemandSelectChannelPage
      }
    }
    currentStep = await nextStepWithChecks(dispatch, currentStep);
    if (currentStep.type === StepType.LoginSuccess) {
      window.location.href = currentStep.payload.successUrl;
      return REDIRECT_SUCCESS; // Indicates redirect in progress, no further action needed
    } else {
      // "nextStepWithChecks" would take care of redirection/error handling
      // If the control comes here, that means WebAuthn wasn't successfull
      throw new AuthTreeError();
    }
  } else {
    currentStep = await progressToChannelSelect(dispatch, currentStep);
    return currentStep;
  }
}
